import { render, staticRenderFns } from "./SideControls.vue?vue&type=template&id=7611e343&"
import script from "./SideControls.vue?vue&type=script&lang=js&"
export * from "./SideControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports